var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-format"},[_c('h2',{staticClass:"format-title"},[_vm._v("键盘快捷方式")]),_c('a-table',{staticClass:"keyboard-shortcut-table",attrs:{"columns":_vm.columns,"dataSource":_vm.list,"pagination":false}}),_c('p',[_vm._v("提示: MacOS 系统请将 Ctrl 替换成 Command.")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }